// extracted by mini-css-extract-plugin
export default {"wrapper":"Event_wrapper__jHalF","title":"Event_title__zRueX","description":"Event_description__qWIu-","green":"Event_green__IXcNx","pink":"Event_pink__mFj0O"};